module.exports = __webpack_public_path__ + "static/media/misc.ad9a864c.jpg";